import { Helmet } from 'react-helmet-async';
// @mui
import { Container, Typography } from '@mui/material';
// components
import { useSettingsContext } from '../components/settings';
import {Dashfirst} from "../sections/@dashboard/Dashfirst";

// ----------------------------------------------------------------------
type Props = {
    socket: any;
};
export default function PageDashfirst({socket}:Props) {
  const { themeStretch } = useSettingsContext();

  return (
    <>
      <Helmet>
        <title> Dashboard do Atendente - Eyhe Maior Comunidade de Suporte Emocional do Brasil </title>
      </Helmet>

      <Dashfirst socket={socket}/>
    </>
  );
}
